const imagePathBuilder = (name: string, ext = 'png', shared = false): string => {
  const basePath = shared ? '/shared' : '/mobile-banking-images';
  return `${basePath}/${name}.${ext}`;
};

export type TrustedBy = {
  title: string;
  icons: Array<{
    url: string;
    alt: string;
    height: number;
    width: number;
  }>;
};

const trustedByState: TrustedBy = {
  title: 'Trusted by 10+ fintech companies',
  icons: [
    {
      url: imagePathBuilder('wirex', 'svg', true),
      alt: 'Wirex',
      width: 108,
      height: 24,
    },
    {
      url: imagePathBuilder('wallex', 'svg', true),
      alt: 'Wallex',
      width: 150,
      height: 28,
    },
    {
      url: imagePathBuilder('talk-remit', 'svg', true),
      alt: 'TalkRemit',
      width: 150,
      height: 24,
    },
    {
      url: imagePathBuilder('lewk', 'svg', true),
      alt: 'Lewk',
      width: 130,
      height: 28,
    },
    {
      url: imagePathBuilder('lolypto', 'svg', true),
      alt: 'Lolypto',
      width: 110,
      height: 32,
    },
    {
      url: imagePathBuilder('sadad', 'svg', true),
      alt: 'Sadad',
      width: 66,
      height: 32,
    },
    {
      url: imagePathBuilder('unknown', 'svg', true),
      alt: 'Unknown',
      width: 30,
      height: 32,
    },
    {
      url: imagePathBuilder('gleec', 'svg', true),
      alt: 'Gleec',
      width: 116,
      height: 28,
    },
  ],
};

export default trustedByState;
